if ( objects.is_front_page) {

    gsap.to("#section-1 .row .col-md-6", {
        autoAlpha: 1,
        duration: 0.25
    })

    const titre = new SplitText("#section-1 h1.accroche", { type: "words,chars" }),
    charsTitre = titre.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charsTitre, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
        trigger: "#section-1 h1.accroche",
        },
        scale: 1,
        stagger: 0.01,
        delay: 1,
        duration: 0.5,
    });

    const accroche = new SplitText("#section-1 h2.accroche-top", { type: "words,chars" }),
    charsaccroche = accroche.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charsaccroche, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
        trigger: "#section-1 h2.accroche-top",
        },
        scale: 1,
        stagger: 0.01,
        delay: 1,
        duration: 0.5,
    });

    const paragraphe = new SplitText("#section-1 p.paragraphe", { type: "words,chars" }),
    charsparagraphe = paragraphe.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charsparagraphe, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
        trigger: "#section-1 p.paragraphe",
        },
        scale: 1,
        stagger: 0.004,
        delay: 1,
        duration: 0.5,
    });

    gsap.fromTo("#section-1 a.button-plus", {
        scale: 0,
    }, {
        scrollTrigger: {
        trigger: "#section-1 a.button-plus",
        },
        scale: 1, 
        ease: "power3.out",
        delay: 0.5,
        duration: 0.75,
    });

    gsap.fromTo("#section-1 a.button-plus span.button-effect", {
        y: 200,
        opacity: 0,
    }, {
        scrollTrigger: {
        trigger: "#section-1 a.button-plus span.button-effect",
        },
        y: 0, 
        ease: "power3.out",
        opacity: 1,
        delay: 1,
        duration: 0.75,
    });

    gsap.fromTo("#section-1 h2.accroche-top .line", {
        x: -200,
        opacity: 0,
    }, {
        scrollTrigger: {
        trigger: "#section-1 h2.accroche-top .line",
        },
        x: 0, 
        ease: "power3.out",
        opacity: 1,
        delay: 0.75,
        duration: 0.45,
    });

    // gsap.fromTo("#section-2 .row p.texte", {
    //     opacity: 0,
    // }, {
    //     scrollTrigger: {
    //     trigger: "#section-2 .row p.texte",
    //     },
    //     ease: "power3.out",
    //     opacity: 1,
    //     delay: 1,
    //     duration: 1,
    // });

    const texte = new SplitText("#section-2 .intro", { type: "words,chars" }),
    charstexte = texte.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charstexte, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
        trigger: "#section-2 .intro",
        },
        scale: 1,
        stagger: 0.004,
        delay: 1,
        duration: 0.5,
    });

    const discover = new SplitText("#section-slider h1", { type: "words,chars" }),
    charsdiscover = discover.chars; //an array of all the divs that wrap each character

    gsap.fromTo(charsdiscover, {
        scale: 0,
        ease: CustomEase.create("custom", "M0,0,C0.422,0,0.766,0.288,0.766,0.702,0.766,1,0.914,1,1,1"),
    }, {
        scrollTrigger: {
        trigger: "#section-slider h1",
        },
        scale: 1,
        stagger: 0.004,
        delay: 1,
        duration: 0.5,
    });


    // let price = document.querySelector(".box-middle .price")
    // const button_minus = document.querySelector(".selecteur .box.moins")
    // const button_plus = document.querySelector(".selecteur .box.plus")
    // const players = document.querySelector(".selecteur .box.nombre")
    // const players_max = players.getAttribute('data-max');
    // const players_min = players.getAttribute('data-min');
    // let nombre = parseInt(players.innerHTML)

    // function cursor() {
    //     if (nombre <= players_min ) {
    //         button_minus.style.cursor = "default"
    //     } else if (nombre >= players_max){
    //         button_plus.style.cursor = "default"
    //     } else {
    //         button_minus.style.cursor = "pointer"
    //         button_plus.style.cursor = "pointer"
    //     }
    // }

    // function calcul() {
    //     players.innerHTML = nombre

    //     switch (nombre) {
    //     case 3:
    //         price.innerHTML = 35
    //         break;
    //     case 4:
    //         price.innerHTML = 30
    //         break;
    //     case 5:
    //         price.innerHTML = 27
    //         break;
    //     default:
    //         price.innerHTML = 24
    //         break;
    //     }
    // }

    // button_minus.addEventListener('click', () => {
    //     if (nombre > players_min ) {
    //       nombre -= 1
    //     }
    //     cursor()
    //     calcul()
    //   })
    //   button_plus.addEventListener('click', () => {
    //     if (nombre < players_max ) {
    //       nombre -= -1
    //     }
    //     cursor()
    //     calcul()
    //   })

    // cursor()
    // calcul()
}